<div class="container mt-3">
  <div class="card shadow-mm">
    <div class="card-header bg-primary text-white">
      <h4 class="mb-0">USER MASTER FORM</h4>
    </div>

    <div class="card-body">
      <form>
        <div class="row g-3">

          <!-- User ID -->
          <!-- <div class="col-md-6">
            <label class="form-label">User ID</label>
            <input type="text"
                   class="form-control form-control-mm"
                   [(ngModel)]="user.Um_iid"
                   name="Um_iid" readonly >
          </div> -->

          <!-- Employee Code -->
          <div class="col-md-6">
            <label class="form-label">Employee Code</label>
            <input type="text"
                   class="form-control form-control-mm"
                   [(ngModel)]="user.Um_Empcode"
                   name="Um_Empcode">
          </div>

          <!-- First Name -->
          <div class="col-md-6">
            <label class="form-label">First Name</label>
            <input type="text"
                   class="form-control form-control-mm"
                   [(ngModel)]="user.Um_FirstName"
                   name="Um_FirstName">
          </div>

          <!-- Username -->
          <div class="col-md-6">
            <label class="form-label">Username</label>
            <input type="text"
                   class="form-control form-control-mm"
                   [(ngModel)]="user.Um_UserName"
                   name="Um_UserName">
          </div>

          <!-- Password -->
          <div class="col-md-6">
            <label class="form-label">Password</label>
            <input type="password"
                   class="form-control form-control-mm"
                   [(ngModel)]="user.Um_Password"
                   name="Um_Password">
          </div>

          <!-- Rights -->
          <div class="col-md-6">
            <label class="form-label">User Rights</label>
            <select class="form-select form-select-mm"
                    [(ngModel)]="user.Um_Rights"
                    name="Um_Rights">
              <option value="">-- Select --</option>
              <option *ngFor="let right of user.rightslist" [value]="right.R_Rightsid">{{ right.R_RightsName }}</option>
            </select>
          </div>

          

          <!-- Created Date -->
          <!-- <div class="col-md-6">
            <label class="form-label">Created Date</label>
            <input type="date"
                   class="form-control form-control-mm"
                   [(ngModel)]="user.Um_Createddate"
                   name="Um_Createddate"
                   readonly>
          </div> -->

          <!-- Created By -->
          

          <!-- Submit -->
          <div class="col-12">
            <div class="d-grid mt-4">
              <button class="btn btn-primary btn-lg"
                      type="button"
                      (click)="onSubmitUser()">
                Save User
              </button>
            </div>
          </div>

        </div>
      </form>
    </div>
  </div>
</div>
